/**
 * Utility functions for handling promotion date conversions
 */

/**
 * Converts a UTC date string to Pacific time, subtracts one second, and formats as MM/DD/YYYY
 * This is used specifically for promotion start and end dates to ensure proper timezone handling
 *
 * @param {string} utcDateString - ISO 8601 UTC date string (e.g., "2025-08-19T07:00:00.000Z")
 * @returns {string} - Formatted date string in MM/DD/YYYY format in Pacific timezone
 */
export const convertUtcToPacificAndFormat = (utcDateString) => {
  if (!utcDateString) {
    return null;
  }
  const utcDate = new Date(utcDateString);
  // Subtract one second from the UTC time
  utcDate.setSeconds(utcDate.getSeconds() - 1);

  // Convert to Pacific time and format as MM/DD/YYYY
  return utcDate.toLocaleDateString('en-US', {
    timeZone: 'America/Los_Angeles'
  });
};